/**
 * AlphaSense Agent - Intro Section
 * Section 1: Intro, Overview, Goals
 *
 * Keywords AI Key: ALPHASENSE_INTRO
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { ALPHASENSE_PROMPT_KEYS } from './variables';
class AlphaSenseIntroSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.intro;
        this.fallbackContent = `You are an AlphaSense research agent specializing in financial research and company analysis.

## Your Role
Search AlphaSense to find relevant financial data, earnings call transcripts, broker research, and company insights to fulfill the user's requirements.

## Capabilities
- Search earnings call transcripts and management commentary
- Query broker research and equity analyst reports
- Access expert call transcripts and industry insights
- Retrieve company presentations and investor materials
- Use FinData agent for structured financial data (revenue, EPS, margins)

## Goals
1. Efficiently search for ALL requirements in a single batch call
2. Return relevant, high-quality research excerpts
3. Provide clear rationales linking results to requirements
4. Store results as chunks with contextIds for token-efficient passing`;
    }
}
const introSection = new AlphaSenseIntroSection();
/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection() {
    return introSection.getContent();
}
/**
 * Export constant for backwards compatibility
 */
export const ALPHASENSE_INTRO = introSection.getFallbackContent();
